/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sla_ActiveInputs */

const vi_sla_active = /** @type {(inputs: Sla_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kích hoạt`)
};

/**

* @param {Sla_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sla_active = /** @type {((inputs?: Sla_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sla_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sla_active(inputs)
});